var _style, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodejsCriandoPrimeiraBiblioteca(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 48 47",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st3{fill:#494949;stroke:#494949;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e589ef",
    d: "M45.9 24.4l.4 4.1L1.6 44.8l.2-8.7.4-4.9L46.7 15l-.7 3.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f799ff",
    d: "M46.2 8.5l-.6 7.4L1.9 31.8v-9.3l.4-4.3 44-16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M5.5 45.8H1.3V1.2h44.9v44.6H30.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9 11.1v5.8l-5.1 2.9-5-2.9v-5.8l5-2.9z",
    className: "st3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#494949",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M30.9 21.4v5.8l-5 2.8-5-2.8v-5.8l5-2.9zM25 11.1v5.8l-5 2.9-5-2.9v-5.8l5-2.9zm-6 10.2v5.8L14 30l-5-2.9v-5.8l5-2.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.6v5.8l-5 2.9-5-2.9v-5.8l5-2.9z",
    className: "st3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejsCriandoPrimeiraBiblioteca);
export default __webpack_public_path__ + "static/media/nodejs-criando-primeira-biblioteca.31284a4e44c60859cb0eb9391bd5bb8a.svg";
export { ForwardRef as ReactComponent };